module.exports = __webpack_public_path__ + "img/poster.390e41b8.jpeg";